import { ReactNode } from 'react';
import { useAppReadiness } from '@/contexts/AppReadinessContext';

interface AppLoadingGateProps {
  children: ReactNode;
}

/**
 * AppLoadingGate - passes through to children immediately.
 * Individual components handle their own skeleton loading states.
 * Only blocks on critical errors.
 */
export function AppLoadingGate({ children }: AppLoadingGateProps) {
  const { hasCriticalError } = useAppReadiness();
  
  // If there's a critical error, still render children - ErrorDisplay will handle it
  if (hasCriticalError) {
    return <>{children}</>;
  }

  // No blocking gate - let skeleton states handle loading
  return <>{children}</>;
}
